
(function () {
  var tpl = document.getElementById('vk-chat-tpl');
  if (!tpl) return;

  /* DEUX FORMES POSSIBLES, ET C'EST L'APP QUI CHOISIT. Son sélecteur de
     bundle rend le bouton tantôt directement dans la coque
     (`shopify-chat`), tantôt un étage plus bas dans un
     `shopify-agent-runtime` — les deux ont été observées sur cette
     boutique, à quelques minutes d'intervalle. On cherche donc la racine
     QUI PORTE le bouton, au lieu de parier sur un chemin. */
  function racine() {
    var hote = document.querySelector('shopify-chat');
    if (!hote || !hote.shadowRoot) return null;
    if (hote.shadowRoot.querySelector('.activator')) return hote.shadowRoot;
    var rt = hote.shadowRoot.querySelector('shopify-agent-runtime');
    if (rt && rt.shadowRoot && rt.shadowRoot.querySelector('.activator')) return rt.shadowRoot;
    return null;
  }

  function pose() {
    var sr = racine();
    if (!sr) return false;
    if (!sr.querySelector('style[data-vk]')) {
      var s = tpl.content.firstElementChild.cloneNode(true);
      s.setAttribute('data-vk', '');
      sr.appendChild(s);
    }
    // Le nom lu à voix haute suit ce qui est écrit.
    var b = sr.querySelector('.activator');
    if (b) {
      b.setAttribute('aria-label', 'Discute avec nous');
      glissable(b);
    }
    return true;
  }

  /* ————————————————————————————————————————————————————————————————
     LE BOUTON SE DÉPLACE

     CE QU'ON DÉPLACE, ET POURQUOI PAS L'ÉVIDENT. L'hôte `shopify-chat`
     est en `position: fixed; inset: 0` : il couvre TOUT l'écran, en
     `pointer-events: none`. Le translater déplacerait une vitre
     invisible, pas le bouton. Ce qui bouge, c'est le cadre absolu qui
     porte le bouton, une marche plus bas dans le shadow root — et il
     n'est pas exposé en `::part`. D'où la feuille clonée à l'intérieur.

     DEUX GESTES, PARCE QUE DEUX ENTRÉES. À la souris, un bouton se
     saisit et se traîne : le glissement part au quatrième pixel, en
     dessous c'est un clic et le chat s'ouvre. Au doigt, ce seuil
     n'existe pas — le même geste sert à faire défiler la page. Il faut
     donc une intention déclarée : deux secondes et demie de contact
     immobile. Dix pixels avant l'échéance et on rend la main au
     défilement, parce que c'est bien ce que la personne voulait.

     LA POSITION SURVIT À LA NAVIGATION. Un bouton qu'on replace à
     chaque page ne se déplace pas vraiment.
     ———————————————————————————————————————————————————————————————— */
  var racineDoc = document.documentElement;
  var CLE = 'vk-chat-pos';
  var MARGE = 8;
  var SEUIL_SOURIS = 4;
  var SEUIL_DOIGT = 10;
  var APPUI = 2500;
  var decore = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  var x = 0, y = 0;
  try {
    var memoire = JSON.parse(localStorage.getItem(CLE) || 'null');
    if (memoire) { x = +memoire.x || 0; y = +memoire.y || 0; }
  } catch (e) {}

  function place(nx, ny) {
    x = nx; y = ny;
    racineDoc.style.setProperty('--vk-chat-x', x + 'px');
    racineDoc.style.setProperty('--vk-chat-y', y + 'px');
  }
  place(x, y);

  // Repère de repos : la boîte MOINS la translation déjà appliquée. Mesuré
  // une fois par geste, pas une fois par image — un `getBoundingClientRect`
  // à chaque `pointermove`, c'est un calcul de mise en page par image.
  function repere(cadre) {
    var r = cadre.getBoundingClientRect();
    return { gx: r.left - x, gy: r.top - y, w: r.width, h: r.height };
  }

  function borne(rep, nx, ny) {
    var vw = window.innerWidth || document.documentElement.clientWidth || 0;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    // UNE FENÊTRE QUI SE DÉCLARE À ZÉRO N'EST PAS UNE FENÊTRE MINUSCULE :
    // c'est une mesure absente. Onglet en arrière-plan, WebView qui n'a
    // pas encore peint, retour depuis le cache de page — `innerWidth` a
    // été mesuré à 0 dans exactement ce cas. Borner là-dessus envoie le
    // bouton hors champ, et il n'en revient pas puisque la position est
    // mémorisée. On rend donc la demande intacte : le prochain
    // redimensionnement recadrera quand il y aura de quoi mesurer.
    if (vw < rep.w + MARGE * 2 || vh < rep.h + MARGE * 2) return [nx, ny];
    return [
      Math.min(vw - rep.w - MARGE - rep.gx, Math.max(MARGE - rep.gx, nx)),
      Math.min(vh - rep.h - MARGE - rep.gy, Math.max(MARGE - rep.gy, ny))
    ];
  }

  // ————— LES ÉCLATS —————
  // Un carré, pas une bulle : la même forme que le curseur et que les
  // filets du site. Une particule ronde aurait été la particule de tout
  // le monde. Semés à la DISTANCE et non à l'image : la densité suit
  // alors la vitesse du geste, et une souris immobile n'en produit aucun.
  var bac = null, vivants = 0;
  function eclats(px, py) {
    if (vivants > 30) return;
    if (!bac) {
      bac = document.createElement('div');
      bac.className = 'vk-chat-etincelles';
      bac.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bac);
    }
    for (var i = 0; i < 2; i++) {
      var d = document.createElement('i');
      d.className = 'vk-chat-eclat';
      d.style.left = (px + (Math.random() * 22 - 11)) + 'px';
      d.style.top = (py + (Math.random() * 22 - 11)) + 'px';
      d.style.setProperty('--dx', (Math.random() * 50 - 25) + 'px');
      d.style.setProperty('--dy', (Math.random() * 42 + 6) + 'px');
      d.style.setProperty('--dr', (Math.random() * 200 - 100) + 'deg');
      d.addEventListener('animationend', function () { vivants--; this.remove(); });
      vivants++;
      bac.appendChild(d);
    }
  }

  var tire = null;
  var minuteur = 0;
  var bloqueClic = false;

  function glissable(btn) {
    if (btn._vkGlisse) return;
    btn._vkGlisse = true;
    var cadre = btn.parentElement;
    if (!cadre) return;
    cadre.setAttribute('data-vk-glissable', '');

    // Une position mémorisée peut être hors écran depuis : un écran plus
    // petit, une fenêtre réduite, un téléphone tourné.
    var rep0 = repere(cadre);
    var p0 = borne(rep0, x, y);
    if (p0[0] !== x || p0[1] !== y) place(p0[0], p0[1]);

    function arrete() {
      clearTimeout(minuteur);
      if (!tire) return;
      cadre.removeAttribute('data-vk-presse');
      cadre.removeAttribute('data-vk-tire');
      racineDoc.classList.remove('vk-chat-tire');
      racineDoc.style.setProperty('--vk-chat-e', '1');
      var abouge = tire.bouge;
      tire = null;
      if (abouge) {
        try { localStorage.setItem(CLE, JSON.stringify({ x: x, y: y })); } catch (e) {}
        // Relâcher au bout d'un déplacement ne doit pas ouvrir le chat.
        // Le drapeau tombe au tour de boucle suivant, donc APRÈS le clic
        // que le navigateur synthétise dans la foulée du `pointerup`.
        bloqueClic = true;
        setTimeout(function () { bloqueClic = false; }, 0);
      }
    }

    btn.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      var doigt = e.pointerType === 'touch';
      tire = {
        id: e.pointerId, x0: e.clientX, y0: e.clientY, ox: x, oy: y,
        lx: e.clientX, ly: e.clientY,
        doigt: doigt, arme: !doigt, bouge: false, rep: repere(cadre)
      };
      if (!doigt) {
        // Capturé dès l'enfoncement : sans ça, une souris rapide sort du
        // bouton avant le quatrième pixel et le glissement ne part jamais.
        // Le clic, lui, est intact — la capture ne l'empêche pas.
        try { btn.setPointerCapture(e.pointerId); } catch (err) {}
        return;
      }
      cadre.setAttribute('data-vk-presse', '');
      racineDoc.style.setProperty('--vk-chat-e', '0.88');
      minuteur = setTimeout(function () {
        if (!tire) return;
        tire.arme = true;
        tire.bouge = true;                 // au doigt, l'armement EST l'intention
        cadre.removeAttribute('data-vk-presse');
        cadre.setAttribute('data-vk-tire', '');
        racineDoc.style.setProperty('--vk-chat-e', '1.06');
        if (navigator.vibrate) { try { navigator.vibrate(18); } catch (err) {} }
        try { btn.setPointerCapture(tire.id); } catch (err) {}
      }, APPUI);
    });

    btn.addEventListener('pointermove', function (e) {
      if (!tire || e.pointerId !== tire.id) return;
      var dx = e.clientX - tire.x0, dy = e.clientY - tire.y0;
      if (!tire.arme) {
        // Le doigt part avant l'échéance : c'est un défilement, pas un
        // appui long. On rend la main sans rien avoir bloqué.
        if (Math.abs(dx) + Math.abs(dy) > SEUIL_DOIGT) arrete();
        return;
      }
      if (!tire.bouge) {
        if (Math.abs(dx) + Math.abs(dy) < SEUIL_SOURIS) return;
        tire.bouge = true;
        cadre.setAttribute('data-vk-tire', '');
        racineDoc.classList.add('vk-chat-tire');
        racineDoc.style.setProperty('--vk-chat-e', '1.04');
        try { btn.setPointerCapture(tire.id); } catch (err) {}
      }
      var p = borne(tire.rep, tire.ox + dx, tire.oy + dy);
      place(p[0], p[1]);
      if (decore && !tire.doigt) {
        var sx = e.clientX - tire.lx, sy = e.clientY - tire.ly;
        if (Math.abs(sx) + Math.abs(sy) >= 14) {
          tire.lx = e.clientX; tire.ly = e.clientY;
          eclats(e.clientX, e.clientY);
        }
      }
    });

    btn.addEventListener('pointerup', arrete);
    btn.addEventListener('pointercancel', arrete);

    // Une fois armé, le doigt pilote le bouton et plus la page. Écouteur
    // NON passif : c'est la seule façon de reprendre le défilement en
    // cours de geste.
    btn.addEventListener('touchmove', function (e) {
      if (tire && tire.arme) e.preventDefault();
    }, { passive: false });

    // Android ouvre son menu contextuel bien avant nos 2,5 s.
    btn.addEventListener('contextmenu', function (e) { if (tire) e.preventDefault(); });
  }

  // En capture sur l'hôte : on passe AVANT l'écouteur de l'app, qui vit
  // sur le bouton lui-même.
  document.addEventListener('click', function (e) {
    if (!bloqueClic) return;
    if (!e.target || e.target.tagName !== 'SHOPIFY-CHAT') return;
    e.stopPropagation();
    e.preventDefault();
  }, true);

  window.addEventListener('resize', function () {
    var sr = racine();
    var b = sr && sr.querySelector('.activator');
    if (!b || !b.parentElement) return;
    var p = borne(repere(b.parentElement), x, y);
    if (p[0] !== x || p[1] !== y) place(p[0], p[1]);
  }, { passive: true });

  /* Le bouton arrive quand l'app le décide, et son shadow root imbriqué
     plus tard encore — un MutationObserver du document ne voit ni l'un
     ni l'autre (les mutations d'un shadow root ne remontent pas). Une
     tentative toutes les 300 ms pendant vingt secondes, sans s'arrêter
     au premier succès : si l'app change de bundle en cours de route,
     elle repart avec un shadow root neuf, et le nôtre est reposé.
     `pose()` est idempotent, deux requêtes par essai. */
  pose();
  var n = 0;
  var t = setInterval(function () {
    pose();
    if (++n > 66) clearInterval(t);
  }, 300);
})();
